<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="600px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>

              <v-row dense class="mt-5">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{ $t('emailtemp_col1') }}</label>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-text-field dense v-model="editedItem.ETEMP_TITLE" hide-details></v-text-field>
                </v-col>
              </v-row>
              <v-row dense class="mt-3">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{ $t('emailtemp_col2') }}</label>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-text-field dense v-model="editedItem.ETEMP_SENDER" hide-details></v-text-field>
                </v-col>
              </v-row>

              <v-row dense class="mt-5">
                <v-col cols="12" class="pa-0">
                  <v-select hide-details v-model="editedItem.ETEMP_LAN" :items="LANLIST" :label="$t('eul_label20')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value" @change="changeintrolan"/>
                </v-col>
              </v-row>

              <mailintrofield v-model="editedItem.ETEMP_INTRO" :lan="editedItem.ETEMP_LAN"/>

              <v-row dense class="mt-5">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("emailtemp_col5")}}</label>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col6')" v-model="editedItem.ED_TITLE" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col7')" v-model="editedItem.ED_DATE" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col13')" v-model="editedItem.ED_TIME" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col8')" v-model="editedItem.ED_PLACE" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col9')" v-model="editedItem.ED_ADDR" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col10')" v-model="editedItem.ED_HOST" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col11')" v-model="editedItem.ED_ORG" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col14')" v-model="editedItem.ED_SPON" hide-details/>
                </v-col>
              </v-row>

              <v-row dense class="mt-5">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("emailtemp_col12")}}</label>
                </v-col>
              </v-row>
              <v-row dense class="mt-0" v-if="infoItem.length > 0">

                <v-checkbox v-if="infoItem[0].USETYPE == 1" :label="infoItem[0].NAME" 
                  v-model="editedItem.EINFO1" dense hide-details class="mr-5  mt-1"/>

                <v-checkbox v-if="infoItem[1].USETYPE == 1" :label="infoItem[1].NAME" 
                  v-model="editedItem.EINFO2" dense hide-details class="mr-5 mt-1"/>
                
                  <v-checkbox v-if="infoItem[2].USETYPE == 1" :label="infoItem[2].NAME" 
                  v-model="editedItem.EINFO3" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[3].USETYPE == 1" :label="infoItem[3].NAME" 
                  v-model="editedItem.EINFO4" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[4].USETYPE == 1" :label="infoItem[4].NAME" 
                  v-model="editedItem.EINFO5" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[5].USETYPE == 1" :label="infoItem[5].NAME" 
                  v-model="editedItem.EINFO6" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[6].USETYPE == 1" :label="infoItem[6].NAME" 
                  v-model="editedItem.EINFO7" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[7].USETYPE == 1" :label="infoItem[7].NAME" 
                  v-model="editedItem.EINFO8" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[8].USETYPE == 1" :label="infoItem[8].NAME" 
                  v-model="editedItem.EINFO9" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[9].USETYPE == 1" :label="infoItem[9].NAME" 
                  v-model="editedItem.EINFO10" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[10].USETYPE == 1" :label="infoItem[10].NAME" 
                  v-model="editedItem.EINFO11" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[11].USETYPE == 1" :label="infoItem[11].NAME" 
                  v-model="editedItem.EINFO12" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[12].USETYPE == 1" :label="infoItem[12].NAME" 
                  v-model="editedItem.EINFO13" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[13].USETYPE == 1" :label="infoItem[13].NAME" 
                  v-model="editedItem.EINFO14" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[14].USETYPE == 1" :label="infoItem[14].NAME" 
                  v-model="editedItem.EINFO15" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[15].USETYPE == 1" :label="infoItem[15].NAME" 
                  v-model="editedItem.EINFO16" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[16].USETYPE == 1" :label="infoItem[16].NAME" 
                  v-model="editedItem.EINFO17" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[17].USETYPE == 1" :label="infoItem[17].NAME" 
                  v-model="editedItem.EINFO18" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[18].USETYPE == 1" :label="infoItem[18].NAME" 
                  v-model="editedItem.EINFO19" dense hide-details class="mr-5 mt-1"/>

                  <v-checkbox v-if="infoItem[19].USETYPE == 1" :label="infoItem[19].NAME" 
                  v-model="editedItem.EINFO20" dense hide-details class="mr-5 mt-1"/>

              </v-row>




              <v-row dense class="mt-5">
                <v-col cols="12" class="pa-0">
                  <label style="font-weight:bold;font-size:16px">{{$t("emailtemp_col20")}}</label>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col21')" v-model="editedItem.EX_TYPE" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col22')" v-model="editedItem.EX_REGDATE" hide-details/>
                </v-col>
                <v-col cols="4">
                  <v-checkbox dense :label="$t('emailtemp_col23')" v-model="editedItem.EX_TIME" hide-details/>
                </v-col>
              </v-row>

            <v-row dense>
              <v-col cols="12" class="pa-0 mt-5 d-flex align-center">
                <img
                  width="19" height="19"
                  src='https://blueorigin-mice-staticweb.s3.ap-northeast-2.amazonaws.com/infoicon.png' 
                  />
                <v-text-field v-model="editedItem.INFO_TITLE1" class="ml-2" outlined dense hide-details
                  :placeholder="$t('emailtemp_col30')"
                  />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" class="pa-0 mt-3">
                <v-textarea color="#4e6ef7" hide-details
                  v-model="editedItem.INFO_DESC1" :label="$t('emailtemp_col31')" value="" outlined 
                  />
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" class="pa-0 mt-5 d-flex align-center">
                <img
                  width="19" height="19"
                  src='https://blueorigin-mice-staticweb.s3.ap-northeast-2.amazonaws.com/infoicon.png' 
                  />
                <v-text-field v-model="editedItem.INFO_TITLE2" class="ml-2" outlined dense hide-details
                  :placeholder="$t('emailtemp_col32')"
                  />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" class="pa-0 mt-3">
                <v-textarea color="#4e6ef7" hide-details
                  v-model="editedItem.INFO_DESC2" :label="$t('emailtemp_col33')" value="" outlined 
                  />
              </v-col>
            </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row class="ml-5" align="center" dense>
      <v-col md="3" sm="12" xs="12" >
        <label class="menunamestyle ml-1">{{this.$session.get("MENUNAME")}}</label>          
      </v-col>
      <v-spacer/>
      <v-col md="3" sm="12" xs="12" v-if="grade >= 50">
        <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      <v-col md="3" sm="12" xs="12" class="pa-0" v-if="SEARCH_COM_IDX > 0">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>
      <v-col cols="1" align="center" class="pa-0">
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
      </v-col>
    </v-row>

    <v-row dense no-gutters>
      <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
    </v-row>
    
    <v-row align="start">
      <v-col class="pa-1">
        <!-- 테이블 -->
        <v-data-table
          :headers="headers"
          :items="itemList"
          :no-data-text="$t('common_nodata')"
          hide-default-footer
          class="datatablestyle"
          :items-per-page="pagerow"
          :search="search"  
          item-key="IDX"
          :loading="loading"
          >
          <template v-slot:header.ETEMP_TITLE>
            <a :class="sort_name=='ETEMP_TITLE'?'cheader_sortselect':'cheader_sort'" @click="customsort('ETEMP_TITLE')">{{$t("emailtemp_col1")}}</a>
          </template>
          <template v-slot:header.ETEMP_SENDER>
            <a :class="sort_name=='ETEMP_SENDER'?'cheader_sortselect':'cheader_sort'" @click="customsort('ETEMP_SENDER')">{{$t("emailtemp_col2")}}</a>
          </template>
          <template v-slot:header.ETEMP_LAN>
            <a :class="sort_name=='ETEMP_LAN'?'cheader_sortselect':'cheader_sort'" @click="customsort('ETEMP_LAN')">{{$t("emailtemp_col3")}}</a>
          </template>
          <template v-slot:header.REG_DATE_NAME>
            <a :class="sort_name=='REG_DATE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('REG_DATE_NAME')">{{$t("emailtemp_col4")}}</a>
          </template>
          <template v-slot:header.actions>
            <label class="cheader_normal" >{{$t("adminbanner_col7")}}</label>
          </template>
  
          <template v-slot:item.ETEMP_LAN="{ item }">
            <label>{{ item.ETEMP_LAN == 0 ? $t('emailtemp_col40') : $t('emailtemp_col41') }}</label>
          </template>

          <template v-slot:item.actions="{ item }">  
              <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
              <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
          </template>     
        </v-data-table>
      </v-col>
    </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  
  

  </v-container>
</template>

<script>
import mailintro from '../assets/js/mailintro.js'

export default {
    data: () => ({

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      sort_name: 'REG_DATE',
      sort_type: true,    //true : DESC, false: ASC

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,

      defaultItem: {
          ETEMP_IDX:'',
          ADMIN_IDX:1,

          ETEMP_TITLE:"",
          ETEMP_SENDER:"",
          ETEMP_LAN:0,
          ETEMP_INTRO:'',

          ED_TITLE:1,
          ED_DATE:1,
          ED_PLACE:1,
          ED_ADDR:1,
          ED_HOST:1,
          ED_ORG:1,
          ED_SPON:1,
          ED_TIME:0,

          EINFO1:1,
          EINFO2:0,
          EINFO3:0,
          EINFO4:0,
          EINFO5:0,
          EINFO6:0,
          EINFO7:0,
          EINFO8:0,
          EINFO9:0,
          EINFO10:0,
          EINFO11:0,
          EINFO12:0,
          EINFO13:0,
          EINFO14:0,
          EINFO15:0,
          EINFO16:0,
          EINFO17:0,
          EINFO18:0,
          EINFO19:0,
          EINFO20:0,

          EX_TYPE:1,
          EX_REGDATE:1,
          EX_TIME:0,

          INFO_TITLE1:'행사 입장 안내',
          INFO_DESC1:'행사장 입구에 마련된 QR 체크인 데스크에서 하단의 입장 QR 코드를 태그하여 입장하여 주시기 바랍니다.',
          INFO_TITLE2:'평점 확인을 위한 체류시간 확인 안내',
          INFO_DESC2:'세션에 참석한 시간에 따라 이수 가능한 평점이 달라집니다. 세션장 입장과 퇴장시 세션장 앞에 구비된 리더기에 반드시 QR 코드를 태그해야 합니다.(1일 2회 이상) QR 태그가 1회인 경우, 체류시간이 신청되지 않습니다. 아래 체류시간 확인 버튼을 눌러 실시간 체류 시간을 확인할 수 있습니다.',

      },
      editedItem: {
      },

      //테이블 정의
      headers: [
        {text: '템플릿명', value: 'ETEMP_TITLE', sortable: false, align:'center', width:400},
        {text: '발송자', value: 'ETEMP_SENDER', sortable: false, align:'center'},
        {text: '언어', value: 'ETEMP_LAN', sortable: false, align:'center' },
        {text: '등록일', value: 'REG_DATE_NAME', sortable: false, align:'center' },
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center'}
      ],
      itemList: [],
      
      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    

      LANLIST:[
          {name:'한국어', name2:"Korean",  value:0}
        , {name:'영어',  name2:"English",   value:1}
      ],
      
      infoItem:[],    //행사별 기본접수양식 커스텀 정보

      SEARCH_COM_IDX: '',
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',

      grade : 0,
      
    }),

    mounted(){
      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {

      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },


      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },



      //행사별 기본접수양식 가져오기
      getInfoItemList(){
        
        this.infoItem.splice(0, this.infoItem.length);   //데이터 초기화
        
        if(this.SEARCH_COM_IDX == null){
            return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          return;
        }

        this.$http.post(this.$host+'/api/InputEventList',{
              ADMIN_IDX: this.$session.get("ADMIN_IDX")
            , COM_IDX:   this.SEARCH_COM_IDX
            , EVENT_IDX: this.SEARCH_EVENT_IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{
          if(result.data.resultCode == 0){
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const list = result.data.resultData;
              list.forEach(element => {
                  this.infoItem.push(element); 
              });

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.loading = false;
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
          if(error.message == 'Request failed with status code 429')
          {
            this.$alert(this.$t("common_reqer"));
          }else{
            this.$alert(error.message);
          }
        });
      },


      loadpage(p){
          
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          
          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/EmailTempList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , LAN_CODE:this.$i18n.locale
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;

                list.forEach(element => {
                    this.itemList.push(element); 
                });

                //요걸 나중에 해줘야 무한반복이 안된다.
                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.getInfoItemList();
        this.loadpage(1);
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        this.dialog_pw  = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //추가 저장
      save () {
        
        if(this.editedItem.ETEMP_TITLE  == undefined || this.editedItem.ETEMP_TITLE.length < 1){
          this.$alert(this.$t('emailtemp_col42'));
          return;
        } 
        if(this.editedItem.ETEMP_SENDER  == undefined || this.editedItem.ETEMP_SENDER.length < 1){
          this.$alert(this.$t('emailtemp_col43'));
          return;
        } 

        /*
        if(this.SEARCH_COM_NAME == undefined || this.editedItem.SEARCH_COM_NAME.length < 1){
          this.$alert(this.$t('common_select_com'));
          return;
        } 
        if(this.SEARCH_EVENT_NAME == undefined || this.editedItem.SEARCH_EVENT_NAME.length < 1){
          this.$alert(this.$t('common_select_event'));
          return;
        } 
        */


        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/EmailTempUpdate',{
                ETEMP_TITLE: escape(this.editedItem.ETEMP_TITLE)
              , ETEMP_SENDER: escape(this.editedItem.ETEMP_SENDER)
              , ETEMP_LAN : this.editedItem.ETEMP_LAN
              , ED_TITLE : this.editedItem.ED_TITLE
              , ED_DATE : this.editedItem.ED_DATE
              , ED_TIME : this.editedItem.ED_TIME
              , ED_PLACE : this.editedItem.ED_PLACE
              , ED_ADDR : this.editedItem.ED_ADDR
              , ED_HOST : this.editedItem.ED_HOST
              , ED_ORG : this.editedItem.ED_ORG
              , ED_SPON : this.editedItem.ED_SPON
              , EINFO1 : this.editedItem.EINFO1
              , EINFO2 : this.editedItem.EINFO2
              , EINFO3 : this.editedItem.EINFO3
              , EINFO4 : this.editedItem.EINFO4
              , EINFO5 : this.editedItem.EINFO5
              , EINFO6 : this.editedItem.EINFO6
              , EINFO7 : this.editedItem.EINFO7
              , EINFO8 : this.editedItem.EINFO8
              , EINFO9 : this.editedItem.EINFO9
              , EINFO10 : this.editedItem.EINFO10
              , EINFO11 : this.editedItem.EINFO11
              , EINFO12 : this.editedItem.EINFO12
              , EINFO13 : this.editedItem.EINFO13
              , EINFO14 : this.editedItem.EINFO14
              , EINFO15 : this.editedItem.EINFO15
              , EINFO16 : this.editedItem.EINFO16
              , EINFO17 : this.editedItem.EINFO17
              , EINFO18 : this.editedItem.EINFO18
              , EINFO19 : this.editedItem.EINFO19
              , EINFO20 : this.editedItem.EINFO20
              , EX_TYPE : this.editedItem.EX_TYPE
              , EX_REGDATE : this.editedItem.EX_REGDATE
              , EX_TIME : this.editedItem.EX_TIME
              , INFO_TITLE1: this.editedItem.INFO_TITLE1 == null || this.editedItem.INFO_TITLE1 == undefined ? '' : escape(this.editedItem.INFO_TITLE1)
              , INFO_DESC1: this.editedItem.INFO_DESC1 == null || this.editedItem.INFO_DESC1 == undefined ? '' : escape(this.editedItem.INFO_DESC1)
              , INFO_TITLE2: this.editedItem.INFO_TITLE2 == null || this.editedItem.INFO_TITLE2 == undefined ? '' : escape(this.editedItem.INFO_TITLE2)
              , INFO_DESC2: this.editedItem.INFO_DESC2 == null || this.editedItem.INFO_DESC2 == undefined ? '' : escape(this.editedItem.INFO_DESC2)
              , ETEMP_INTRO: this.editedItem.ETEMP_INTRO == null || this.editedItem.ETEMP_INTRO == undefined ? '' : escape(this.editedItem.ETEMP_INTRO)
              , COM_IDX: this.editedItem.COM_IDX
              , ETEMP_IDX: this.editedItem.ETEMP_IDX
              , EVENT_IDX: this.editedItem.EVENT_IDX
              , ADMIN_IDX: this.editedItem.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{
          
          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/EmailTempInsert',{
                ETEMP_TITLE: escape(this.editedItem.ETEMP_TITLE)
              , ETEMP_SENDER: escape(this.editedItem.ETEMP_SENDER)
              , ETEMP_LAN : this.editedItem.ETEMP_LAN
              , ED_TITLE : this.editedItem.ED_TITLE
              , ED_DATE : this.editedItem.ED_DATE
              , ED_TIME : this.editedItem.ED_TIME
              , ED_PLACE : this.editedItem.ED_PLACE
              , ED_ADDR : this.editedItem.ED_ADDR
              , ED_HOST : this.editedItem.ED_HOST
              , ED_ORG : this.editedItem.ED_ORG
              , ED_SPON : this.editedItem.ED_SPON
              , EINFO1 : this.editedItem.EINFO1
              , EINFO2 : this.editedItem.EINFO2
              , EINFO3 : this.editedItem.EINFO3
              , EINFO4 : this.editedItem.EINFO4
              , EINFO5 : this.editedItem.EINFO5
              , EINFO6 : this.editedItem.EINFO6
              , EINFO7 : this.editedItem.EINFO7
              , EINFO8 : this.editedItem.EINFO8
              , EINFO9 : this.editedItem.EINFO9
              , EINFO10 : this.editedItem.EINFO10
              , EINFO11 : this.editedItem.EINFO11
              , EINFO12 : this.editedItem.EINFO12
              , EINFO13 : this.editedItem.EINFO13
              , EINFO14 : this.editedItem.EINFO14
              , EINFO15 : this.editedItem.EINFO15
              , EINFO16 : this.editedItem.EINFO16
              , EINFO17 : this.editedItem.EINFO17
              , EINFO18 : this.editedItem.EINFO18
              , EINFO19 : this.editedItem.EINFO19
              , EINFO20 : this.editedItem.EINFO20
              , EX_TYPE : this.editedItem.EX_TYPE
              , EX_REGDATE : this.editedItem.EX_REGDATE
              , EX_TIME : this.editedItem.EX_TIME
              , INFO_TITLE1: this.editedItem.INFO_TITLE1 == null || this.editedItem.INFO_TITLE1 == undefined ? '' : escape(this.editedItem.INFO_TITLE1)
              , INFO_DESC1: this.editedItem.INFO_DESC1 == null || this.editedItem.INFO_DESC1 == undefined ? '' : escape(this.editedItem.INFO_DESC1)
              , INFO_TITLE2: this.editedItem.INFO_TITLE2 == null || this.editedItem.INFO_TITLE2 == undefined ? '' : escape(this.editedItem.INFO_TITLE2)
              , INFO_DESC2: this.editedItem.INFO_DESC2 == null || this.editedItem.INFO_DESC2 == undefined ? '' : escape(this.editedItem.INFO_DESC2)
              , ETEMP_INTRO: this.editedItem.ETEMP_INTRO == null || this.editedItem.ETEMP_INTRO == undefined ? '' : escape(this.editedItem.ETEMP_INTRO)
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
              , ADMIN_IDX:this.$session.get("ADMIN_IDX")
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }

        this.close()
      },      

      //검색
      search_run(){
        this.loadpage(1);
      },
      
      //신규 추가
      newinsert(){
        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedItem.COM_NAME = this.SEARCH_COM_NAME;
        this.editedItem.COM_IDX  = this.SEARCH_COM_IDX;
        mailintro.fill(this, this.editedItem);   //상단 안내 문구에 기본 문구를 미리 채움
        this.dialog = true;
      },

      //템플릿 언어 변경 → 상단 안내 문구도 그 언어 기본 문구로 (고친 문구면 확인 후)
      changeintrolan(){
        mailintro.changelan(this, this.editedItem);
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        this.editedItem = Object.assign({ ETEMP_INTRO:'' }, item);
        mailintro.fill(this, this.editedItem);   //저장된 문구가 없으면 기본 문구를 미리 채움
        this.dialog = true;
      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/EmailTempDelete',{
              ETEMP_IDX:item.ETEMP_IDX
            , COM_IDX: item.COM_IDX
            , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COM_IDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
          this.$session.set("OPTION_IDX", null);
          this.$session.set("OPTION_NAME",'');
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.$session.set("OPTION_IDX", null);
          this.$session.set("OPTION_NAME",'');
        }
        this.loadpage(1);
      },    

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.loadpage(1);
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.loadpage(1);
      },


    },
  
}
</script>


<style lang="css">
  td{
    height: 36px !important;
  }
</style>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>
  
  .v-input--selection-controls{
    margin-top:0px;
  }

</style>